/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';

import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';

import { Observable } from 'rxjs';

import { AelDto } from './ael.dto';
import { AelMapper } from './ael.mapper';

@Injectable()
export class AelRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(filter: any, entityType?: string, entityId?: ID, eventTypeIds?: number[]): SlicedDataSource<AelDto> {
    const req = {
      eventEntityType: entityType ? entityType.toUpperCase() : void 0,
      entityId,
      eventTypeIds,
      searchString: filter.searchString,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };

    return this.createSlicedDataSourceGet(
     `${this.bp}/ael`,
     req, undefined, arrayOf(AelMapper));
  }

  findAll(): Observable<AelDto[]> {
    return this.httpGet(`${this.bp}/ael`, arrayOf(AelMapper));
  }

  get(id: ID): Observable<AelDto> {
    return this.httpGet(`${this.bp}/ael/${id}`, AelMapper);
  }
}
